import { yup, strictObjectSchema, makeOptionalAndRequiredSchemas, makeOptionalObjectSchema } from './validationLib.js';
import {
  nameOptionalSchema,
  emailRequiredSchema,
  phoneNumberOptionalSchema,
  taxIdRequiredSchema,
  addressOptionalSchema,
  userBirthdayOptionalSchema,
  taxIdOptionalSchema,
  emailOptionalSchema,
  payrollElectionSchema,
  languagePreferenceOptionalSchema,
  nameRequiredSchema,
  employerSchema,
  requiredToBeOnboardedAdmin,
  requiredToBeThirdPartyPayrollAdmin,
} from './userValidations.js';

const payrollProviderOptionalSchema = yup.string().label('payrollProvider');

const createEmployerClientSchema = strictObjectSchema({
  ...employerSchema.fields,
  payrollProvider: payrollProviderOptionalSchema,
});

const createEmployerSchema = createEmployerClientSchema
  .testContext(...requiredToBeOnboardedAdmin)
  .testContext(...requiredToBeThirdPartyPayrollAdmin);

const updateEmployerSchema = strictObjectSchema({
  ...employerSchema.fields,
  payrollProvider: payrollProviderOptionalSchema,
});

const clientEmployeeIdSchema = yup.string().label('clientEmployeeId');

const createEmploymentSchema = strictObjectSchema({
  clientEmployeeId: clientEmployeeIdSchema,
  name: nameRequiredSchema,
  email: emailRequiredSchema,
  phoneNumber: phoneNumberOptionalSchema,
  languagePreference: languagePreferenceOptionalSchema,
  taxId: taxIdRequiredSchema,
  address: addressOptionalSchema,
  birthday: userBirthdayOptionalSchema,
});

const updateEmploymentSchema = strictObjectSchema({
  clientEmployeeId: clientEmployeeIdSchema,
  name: nameOptionalSchema,
  email: emailOptionalSchema,
  phoneNumber: phoneNumberOptionalSchema,
  languagePreference: languagePreferenceOptionalSchema,
  taxId: taxIdOptionalSchema,
  address: addressOptionalSchema,
  birthday: userBirthdayOptionalSchema,
});

const updateEmploymentEmployeeIdSchema = strictObjectSchema({
  clientEmployeeId: clientEmployeeIdSchema,
});

const updateEmployerEmploymentPayrollElectionSchema = strictObjectSchema({
  employerConfirmedPayrollElection: payrollElectionSchema,
});

export {
  createEmployerClientSchema,
  createEmployerSchema,
  updateEmployerSchema,
  createEmploymentSchema,
  updateEmploymentSchema,
  updateEmploymentEmployeeIdSchema,
  updateEmployerEmploymentPayrollElectionSchema,
};
